import classNames from 'classnames';

import VARIANTS from '../../constants/variants';
import type { FCC } from '../../types/common';
import { ui } from '../../utils/helpers';
import type { LabelVariantType } from './label_types';

import styles from './label.module.css';

type Props = {
  className?: string;
  variant?: LabelVariantType;
  uiKey?: string;
  wrap?: boolean;
};

const Label: FCC<Props> = ({
  className,
  variant = 'info',
  uiKey,
  wrap,
  children,
}) => (
  <span
    className={classNames(
      className,
      styles.root,
      variant ? styles[variant] : undefined,
      wrap ? styles.wrap : undefined,
    )}
    {...ui(uiKey)}
    role="status"
  >
    {children}
  </span>
);

export { VARIANTS };
export default Label;
